import React from "react";
import "./curriculumInfo.scss";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import TabsSet from "componets/molecules/comunityTabs/tabsSet";
import CurriculumTable from "componets/molecules/curriculumTable/curriculumTable";
const CurriculumInfo = ({ data }) => {
  const [loadingData, setLoadingData] = React.useState(true);
  const [tabs, setTabs] = React.useState([]);

  React.useEffect(() => {
    if (loadingData) {
      if (data) {
        let auxtabs = [];
        data.map((section, index) => {
          auxtabs.push({ value: index, text: section.sectionTitle });
        });
        setTabs(auxtabs);
        setLoadingData(false);
      }
    }
  }, [loadingData]);
  const [selected, setSelected] = React.useState(0);
  return (
    <>
      {!loadingData ? (
        <>
          <TabsSet
            textSize={3}
            tabsData={{ groupName: "curriculumCategory", tabs: tabs }}
            setSelected={setSelected}
          />
          <br />
          <br />
          <CurriculumTable data={data[selected]} />
        </>
      ) : (
        "Cargando datos"
      )}
    </>
  );
};

export default CurriculumInfo;
